import { SceneSpine } from "GameObjects/StoryGame/SceneSpine";
import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Bounce, Circ, Elastic, Expo, Linear, Sine, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import { ch8_p02 } from "../../../layouts/ch8_p02/ch8_p02";

export class Chapter8Page2 extends AbstractStoryState implements ReturnType<typeof ch8_p02> {

    readonly bg = this.addChild(new SceneSprite());
    readonly holly = this.addChild(new SceneSprite());
    readonly grass = this.addChild(new SceneSprite());
    readonly speedlines = this.addChild(new SceneSprite());

    readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch8_p02/"));
    readonly frameRight = this.addChild(SceneSprite.withPrefix("ch8_p02/"));

    readonly linesRight = this.addChild(SceneSprite.withPrefix("ch8_p02/"));
    readonly linesLeft = this.addChild(SceneSprite.withPrefix("ch8_p02/"));

    dontScaleUp = true;

    public init(pSize: PIXI.Point, pData: any) {
        // exported layouts from Animate CC
        ch8_p02.call(this);
        // super.init calls onResize
        super.init(pSize, pData);
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
    }

    public animateIn(pOnComplete: () => void) {
        super.animateIn(pOnComplete);
    }

    public animateOut(pOnComplete: () => void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        super.onAnimateInComplete();

        TweenLite.delayedCall(1.5, ()=>{
            this.gotoNextState({transition: "left"});
        });
    }
}